import React from 'react'
import Svg, {Path} from 'react-native-svg'

import {type Props, useCommonSVGProps} from '#/components/icons/common'

// Filled globe (uploaded asset `earth.svg`). Used as the article image-area
// fallback. Rendered with the default (nonzero) fill rule — not the icon
// template's `evenodd` — so the outer ring stays hollow as authored. Defaults
// to the asset's colour; pass `fill` to override.
const EARTH_PATH =
  'M0 12C0 5.39062 5.34375 0 12 0C18.6094 0 24 5.39062 24 12C24 18.6562 18.6094 24 12 24C5.34375 24 0 18.6562 0 12ZM12 21.75C17.3438 21.75 21.75 17.3906 21.75 12C21.75 6.65625 17.3438 2.25 12 2.25C6.60938 2.25 2.25 6.65625 2.25 12C2.25 17.3906 6.60938 21.75 12 21.75ZM19.2188 12L18.4219 9.60938C18.1875 8.85938 18.5625 8.0625 19.3125 7.73438L21.75 6.75L22.5 13.5L20.2969 12.9844C19.7812 12.8438 19.3594 12.4688 19.2188 12ZM3.14062 9.84375L2.25 8.25L3 6L6.75 2.25L11.625 0.75L12.5625 2.48438C12.8906 3.04688 12.8438 3.70312 12.4219 4.21875L11.6719 5.0625C11.2031 5.625 11.2031 6.42188 11.6719 6.98438L12.2812 7.73438C12.5625 8.0625 12.5625 8.48438 12.375 8.8125C12.1406 9.14062 11.7188 9.32812 11.3438 9.1875L10.2188 8.8125C9.89062 8.71875 9.5625 8.71875 9.23438 8.90625L8.95312 9.04688C8.53125 9.23438 8.34375 9.75 8.48438 10.1719C8.57812 10.4062 8.71875 10.5938 8.90625 10.6875L10.5469 11.625C10.9688 11.9062 11.4844 12 12 12H14.0625C14.625 12 15.2344 12.2812 15.6562 12.7031L15.7969 12.8438C16.2188 13.2656 16.5 13.875 16.5 14.4375V14.8594C16.5 15.6562 16.0312 16.4062 15.3281 16.7812L14.9062 17.0625C14.25 17.4375 13.7344 18.0469 13.5 18.8438L13.4531 19.0781C13.2188 19.8281 12.6562 20.3906 11.9062 20.625C11.2031 20.8125 10.4531 20.2969 10.4531 19.5469V18.0938C10.4531 17.5781 10.1719 17.1094 9.70312 16.875C9.28125 16.6875 8.95312 16.2188 8.95312 15.7031V13.8281C8.95312 12.9844 8.4375 12.2344 7.59375 12L4.92188 11.25C4.125 11.0156 3.51562 10.5 3.14062 9.84375Z'

export const EarthFilledIcon = React.forwardRef<Svg, Props>(
  function EarthFilledIcon(props, ref) {
    const {fill, size, style, ...rest} = useCommonSVGProps({
      fill: '#A59CAE',
      ...props,
    })
    return (
      <Svg
        fill="none"
        {...rest}
        ref={ref}
        viewBox="0 0 24 24"
        width={size}
        height={size}
        style={[style]}>
        <Path fill={fill} d={EARTH_PATH} />
      </Svg>
    )
  },
)
